<h6 mat-dialog-title class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  {{ sysText.titleMessageDialog_title | titlecase }}
</h6>

<mat-dialog-content>
  <p class="body2">
    {{ sysText.titleMessageDialog_message }}
  </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button class="button" [mat-dialog-close] color="accent">
    {{ sysText.titleMessageDialog_button }}
  </button>
</mat-dialog-actions>
